import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { I18nService } from 'src/app/services/i18n.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { DialogContentLogin } from '../header-sticky/login-dialog/dialog-content-login';
import { pathRoutingEnum } from 'src/assets/constantEnum';
import { getPasswordStrength, passwordPolicyValidator, PasswordStrengthLevel } from 'src/app/shared/password-strength';

function passwordsMatchValidator(group: FormGroup): ValidationErrors | null {
  const password = group.get('password')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;
  return password === confirmPassword ? null : { passwordsMismatch: true };
}

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  resetForm!: FormGroup;
  token = '';
  submitted = false;
  loading = false;
  success = false;
  invalidLink = false;
  error = '';
  strengthLevel: PasswordStrengthLevel = 'faible';

  private i18n = inject(I18nService);

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    if (!this.token) {
      this.invalidLink = true;
      return;
    }

    this.resetForm = this.formBuilder.group({
      password: ['', [passwordPolicyValidator()]],
      confirmPassword: ['']
    }, { validators: passwordsMatchValidator });

    this.resetForm.get('password')?.valueChanges.subscribe((value: string) => {
      this.strengthLevel = getPasswordStrength(value).level;
    });
  }

  get f() { return this.resetForm.controls; }

  onSubmit(): void {
    this.submitted = true;

    if (this.resetForm.invalid) {
      return;
    }

    this.loading = true;
    this.error = '';

    this.userService.resetPassword(this.token, this.f.password.value).subscribe(() => {
      this.loading = false;
      this.success = true;
    }, (err) => {
      this.loading = false;
      this.error = err || this.i18n.t('auth.resetExpiredLink');
    });
  }

  openLogin(): void {
    this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
    this.dialog.open(DialogContentLogin, { width: '550px' });
  }
}
